/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// eslint-disable-next-line jsx-a11y/click-events-have-key-events

import React, { useEffect, useState } from 'react';
import Media from 'react-media';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { compose } from 'recompose';
import {
    bool, object, arrayOf, number, shape, string, array,
} from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import Box from '@material-ui/core/Box';
import { Pagination } from '@material-ui/lab';
import qs from 'qs';

import mbpUtil from 'mbp-api-util';
import mbpLogger from 'mbp-logger';

import withPageView from '../../../../helpers/tracking/hocs/withPageView';
import DeliveryHours from './DeliveryHours';
import OrderList from './OrderList';
import TrackOrderByZipCode from './TrackOrderByZipCode';
import Loading from '../../common/Loading';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import { TrackOrderStyle } from '../../style/TrackOrderStyle';
import getSiteConfig from '../../utils/getSiteConfig';
import DesktopOrderHeader from '../DesktopOrdersList/DesktopOrderHeader';
import DesktopTrackOrder  from './DesktopTrackOrder/DesktopTrackOrder';
import ErrorPage from '../../common/ErrorPage';
import GraphqlSeoHeadTags from '../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import OrderTrackingOutage from '../OrderTrackingOutage/OrderTrackingOutage';
import { getAddToCartError } from '../../../../../state/ducks/AddToCart/AddToCart-Selectors';
import { getSSRDeviceType } from '../../../../../state/ducks/App/App-Selectors';
import { trackPage } from '../../../../helpers/tracking/common/commonTrackingHelpers';
import { getIsAuthenticatedStatus, getBrand, getProfileInfo } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import AccountHome from '../MyAccount/AccountHome';
import GenericSkeleton from '../../../../components/GraphqlComponents/GraphqlSkeletonComponents/GenericSkeleton';
import { uuidv4 } from '../../../../helpers/uuid';
import { getCryptedOrderDetailsURL } from '../../utils/crypto';
import fetchOrderDetailsV2API from '../../../../../apis/order-apis/fetchOrderDetailsV2';
import { getAccessTokenSafely } from '../../../../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';
import { getChannelUser } from '../../state/reducers/Helper';
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import useFetchAPI from '../../common/customHooks/useFetchAPI';
import LinkOpenChat from '../../common/LinkOpenChat';
import { commonUseStyles } from '../../style/commonStyles';
import { isStandalone } from '../../../../helpers/common/helper';

const styles = ({ typography, palette }) => TrackOrderStyle(typography, palette);

const TrackOrders = ({ classes, userProfile }) => {
    const history = useHistory();
    const customClasses = commonUseStyles();

    // We store pagination count in sessionStorage because it was causing too many state issues when stored in redux
    const PaginationCurrentPage = parseInt(sessionStorage.getItem('account_pagination')) || 1;
    const [currentPage, setCurrentPage] = useState(PaginationCurrentPage);
    const [pageChangeClicked, setIsPageChangeClicked] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [ROSSOrders, setRossOrders] =  useState([]);
    const [totalPages, setTotalPages] = useState(1);

    const isFetchingModal = useSelector((state) => state.account.isFetchingModal);
    const brand = useSelector(getBrand);
    const addToCartError = useSelector(getAddToCartError);
    const ssrDeviceType = useSelector(getSSRDeviceType);
    const getAuthenticatedStatus = useSelector(getIsAuthenticatedStatus);
    const profileInfo = useSelector(getProfileInfo);
    const featureFlags = useSelector(getFeatureFlags);

    const breakpointExpr =  `(max-width: ${(CUSTOM_BREAKPOINTS.tabLandscape)}px)`;
    const brandDisplayName = brand?.['display-name'] || brand?.['description'];
    const seo = {
        page_title: `Order Tracking to Track Your ${brandDisplayName} Order | ${brandDisplayName}`,
        meta_description: `Easily track your ${brandDisplayName} order by signing in to your account, or by inputting your order number. Delivery hours based on recipient's time zone: Residential: 9am-8pm & Business: 9am-6pm.`,
        location: { pathname: '/account/orders' },
    };

    // Shows Small Pagination for devices that can't handle medium
    const isRossV2PaginationEnabled = featureFlags['is-using-new-ross-object'];
    const isROSSEnabled = featureFlags['is-order-page-using-ross-endpoint'];
    const isROSSUIEnabled = featureFlags['is-orders-page-using-ross'];
    const isATLASMaintenanceAlertEnabled = featureFlags['is-atlas-maintenance-alert-enabled'];
    const isRossErrorPageEnabled = featureFlags['is-ross-error-page-enabled'];
    const isWebUsingNewChannelCode = featureFlags['is-web-using-new-channel-codes'];

    const onSuccess = ({ data }) => {
        const rossOrders = [];
        if (Array.isArray(data.result)) {
            if (data.totalPages > 1) {
                setTotalPages(data.totalPages);
            }
            data.result.forEach((ordersList) => {
                ordersList.orders.forEach((order) => {
                    order.uuid = (order.uuid && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(order.uuid)) ? (order.uuid) : uuidv4();
                    rossOrders.push(order);
                });
            });
            setRossOrders(rossOrders);
        }
    };

    const onError = (err) => {
        setErrorMessage(`error fetching ROSS orders by email v2: ${err}`);
        mbpLogger.logError({
            function: 'createROSSDataMutation',
            appName: process.env.npm_package_name,
            module: 'TrackOrder',
            message: errorMessage,
        });
    };

    const createROSSDataMutation = useFetchAPI(onSuccess, onError, fetchOrderDetailsV2API, true);

    const fetchOrdersByEmail = async () => {
        const accessToken = await getAccessTokenSafely();
        const user = getChannelUser(ssrDeviceType, getSiteConfig('domain'), isWebUsingNewChannelCode);
        const payload = { user, email: profileInfo.email };
        const internalToken = (user.indexOf('30001') > -1) ? mbpUtil.getEnv('ROSS_TOKEN_DESKTOP') : mbpUtil.getEnv('ROSS_TOKEN_MOBILE');
        createROSSDataMutation.mutate({
            jwt: accessToken, requestBody: payload, page: currentPage, header: internalToken,
        });
    };

    useEffect(() => {

        const params = qs.parse(window.location.search);
        if (window && window.location && window.location.search !== '') {
            if (params && params.orderStatusId && params.utm_medium === 'SMS') {
                const uuid = uuidv4();
                if (params.orderStatusId && uuid && (userProfile.isAuthenticated || getAuthenticatedStatus)) {
                    // redirect to the order detail page
                    const ordersURL = getCryptedOrderDetailsURL(params.orderStatusId, uuid, null, null, null);
                    return history.push(ordersURL);
                }
            }
        }

        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }

        return () => {
            // Reset pagination between sessions only if the customer is not browsing orders - otherwise we want to keep the current pagination
            if (!(window !== undefined && window.location.pathname.includes('/account/orders'))) sessionStorage.setItem('account_pagination', 1);
            if (!getAuthenticatedStatus && errorMessage) {
                setErrorMessage('');
            }
        };
    }, []);

    useEffect(() => {
        // isAuthenticated wasn't immediately updated by Auth0 if users sign in from /account/orders
        // so we use `getIsAuthenticatedStatus` to get the login status instead
        // fetching order list if user is clicking sign in on global header from orders page
        if ((getAuthenticatedStatus && profileInfo?.email?.includes('@'))) {
            fetchOrdersByEmail();
        }
    }, [getAuthenticatedStatus, currentPage, profileInfo.email]);

    const handleBackToTopClicked = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    const showStockErrorMessage = () => (
        <div className="add-to-cart-error">We&apos;re sorry, this product is not available for purchase.
            Please try again later or contact customer service for assistance
        </div>
    );

    const showTrackingWidgetForSameLogicalItems = (ROSSOrder = {}, currentItem = {}) => {
        /*
      Items under the same logical order only display one tracker, because they should ship together.
      In cases when they ship separately, we need to display different trackers.
      Condition:
          1. If intOrderNumber is the same for the current item as the ROSS order, then they are part of the same logical. Thus one tracker.
          2. However, if the current item has a different tracking number from the first item, then we need to display the tracker.
      */
        const [ROSSOrderIntOrderNumber, ROSSOrderTrackingNumber] = [ROSSOrder.intOrderNumber, ROSSOrder.trackingNumber];
        const [currentItemIntOrderNumber, currentItemTrackingNumber] = [currentItem.intOrderNumber, currentItem.trackingNumber];
        const isSameLogicalOrder = ROSSOrderIntOrderNumber === currentItemIntOrderNumber;
        const isAddon = currentItem.addonType;
        if (isSameLogicalOrder || isAddon) {
            return (currentItemTrackingNumber !== '') && (ROSSOrderTrackingNumber !== currentItemTrackingNumber);
        }
        return true;
    };

    const handlePageChange = (_, page) => {
        if (currentPage !== page) {
            setRossOrders([]);
            setCurrentPage(page);
            setIsPageChangeClicked(true);
            sessionStorage.setItem('account_pagination', page);
            handleBackToTopClicked();
        }
    };

    const getWindowInnerWidth = () => {
        if (typeof window !== 'undefined') {
            return window.innerWidth;
        }
        return 375;
    };

    const isShowingSmallPagination = getWindowInnerWidth() < 375 || false;

    if ((isFetchingModal) && userProfile.isAuthenticated) {
        return <Loading pageTitle="Orders" />;
    }

    if (isATLASMaintenanceAlertEnabled) {
        return <OrderTrackingOutage />;
    }

    if ((errorMessage ||  isRossErrorPageEnabled === true)) {
        const error = {
            isErrorResponse: errorMessage,
            component: `Order History-${ssrDeviceType}`,
        };

        return (
            <>
                {userProfile.isAuthenticated || getAuthenticatedStatus ? (
                    <Media query={breakpointExpr}>
                        {(matches) => (
                            matches ? (
                                <div>
                                    <div className={customClasses.container}>
                                        <AccountHome disablePageView />
                                    </div>
                                    <div className={customClasses.orderContainer}>
                                        <h1>
                                            Order Tracking
                                        </h1>
                                    </div>
                                    <ErrorPage errors={error} />
                                </div>
                            ) : (
                                <>
                                    {/* Account Left Menu Was Here */}
                                    <Grid item xs={10} className={customClasses.gridItem}>
                                        <DesktopOrderHeader />
                                        <ErrorPage errors={error} />
                                    </Grid>
                                </>
                            )
                        )}
                    </Media>
                ) : (
                    <>
                        <ErrorPage error={error} />
                    </>
                )}
            </>
        );
    }

    return (
        <>
            <GraphqlSeoHeadTags seoData={seo} />
            {(userProfile.isAuthenticated || getAuthenticatedStatus)
                ? (
                    <Media query={breakpointExpr}>
                        {(matches) => (
                            matches ? (
                                <>
                                    <div className={classes.TrackOrderStyle}>
                                        <div className={customClasses.container}>
                                            <AccountHome disablePageView />
                                        </div>
                                        <div className={customClasses.orderContainer}>
                                            <h1>
                                                Order Tracking
                                            </h1>
                                        </div>
                                        <DeliveryHours />
                                        {(ROSSOrders?.length > 0) &&  (
                                            <OrderList
                                                userProfile={userProfile}
                                                ROSSOrders={isROSSEnabled ? ROSSOrders : null}
                                                isROSSUIEnabled={isROSSUIEnabled}
                                                showTrackingWidgetForSameLogicalItems={showTrackingWidgetForSameLogicalItems}
                                                isRossV2PaginationEnabled={isRossV2PaginationEnabled}
                                            />
                                        )}
                                        {(ROSSOrders?.length === 0 && pageChangeClicked) && (
                                            <GenericSkeleton height="200px" width="100%" repeatCount={10} />
                                        )}
                                        {isRossV2PaginationEnabled && ROSSOrders?.length > 0
                                            ? (
                                                <Box height="100px" display="flex" justifyContent="center" alignItems="center">
                                                    <Pagination id="mobile-pagination" count={totalPages} size={`${isShowingSmallPagination ? 'small' : 'medium'}`} onChange={handlePageChange} page={currentPage} />
                                                </Box>
                                            ) : null}
                                        {(ROSSOrders?.length > 2) ? (
                                            <span className="back-to-top-wrapper">
                                                <a
                                                    className="back-to-top-link"
                                                    onClick={() => handleBackToTopClicked()}
                                                >
                                                    Back to Top <KeyboardArrowUp />
                                                </a>
                                            </span>
                                        ) : (
                                            ''
                                        )}
                                        {(ROSSOrders?.length === 0 && !pageChangeClicked && !isStandalone) && (
                                            <div>
                                                Can&apos;t find your order?{' '}
                                                <LinkOpenChat>Chat with us</LinkOpenChat>
                                            </div>
                                        )}
                                    </div>
                                </>
                            ) : (
                                <Grid item xs={10} className={`${classes.TrackOrderStyle} ${customClasses.gridItem}`}>
                                    <DesktopOrderHeader />
                                    {addToCartError?.length > 0 && showStockErrorMessage()}
                                    {(ROSSOrders?.length > 0)
                                          && (
                                              <OrderList
                                                  userProfile={userProfile}
                                                  ROSSOrders={isROSSEnabled ? ROSSOrders : null}
                                                  isROSSUIEnabled={isROSSUIEnabled}
                                                  showTrackingWidgetForSameLogicalItems={showTrackingWidgetForSameLogicalItems}
                                                  isRossV2PaginationEnabled={isRossV2PaginationEnabled}
                                              />
                                          )}
                                    {(ROSSOrders?.length === 0 && pageChangeClicked) && (
                                        <GenericSkeleton height="200px" width="100%" repeatCount={10} />
                                    )}
                                    {isRossV2PaginationEnabled && ROSSOrders?.length > 0
                                        ? (
                                            <Box height="100px" display="flex" justifyContent="center" alignItems="center">
                                                <Pagination id="desktop-pagination" count={totalPages} size="large" onChange={handlePageChange} page={currentPage} />
                                            </Box>
                                        ) : null}
                                    {(ROSSOrders?.length === 0 && !pageChangeClicked && !isStandalone) && (
                                        <div className="desktop-no-orders">
                                            Can&apos;t find your order?{' '}
                                            <LinkOpenChat>Chat with us</LinkOpenChat>
                                        </div>
                                    )}
                                </Grid>
                            )
                        )}
                    </Media>
                ) : (
                    <Media query={breakpointExpr}>
                        {(matches) => (
                            matches ? (
                                <>
                                    <DeliveryHours />
                                    <h1>Guest Order Tracking</h1>
                                    <TrackOrderByZipCode mobile />
                                </>
                            ) : (
                                <DesktopTrackOrder
                                    brand={brand}
                                />
                            )
                        )}
                    </Media>
                )}
        </>
    );
};

TrackOrders.defaultProps = {
    ROSSOrders: [],
};

TrackOrders.propTypes = {
    classes: object.isRequired,
    ROSSOrders: arrayOf(
        shape({
            brandId: string,
            modifiedDateTime: string,
            orderNumber: string,
            modifyOrder: string,
            uuid: string,
            status: string,
            orders: arrayOf(
                shape({
                    carrier: string,
                    history: array,
                    brandId: string,
                    type: string,
                    deliveryDate: string,
                    modifiedDateTime: string,
                    status: string,
                    statusDescription: string,
                    trackingNumber: string,
                    warningMessage: string,
                    items: arrayOf(
                        shape({
                            duration: string,
                            interval: string,
                            itemType: string,
                            prdImgCtg: string,
                            prdImgTmn: string,
                            productName: string,
                            productSku: string,
                            seoUrl: string,
                            subscriptionType: string,
                        }),
                    ),
                }),
            ),
        }),
    ),
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
    }).isRequired,
};

const enhance = compose(
    trackPage({
        type: 'ordertracking',
        name: 'ordersearch',
        accountPage: true,
    }),
    withStyles(styles, { withTheme: true }),
    withPageView({
        pageViewSuccessTest: () => true,
    })
);

export default enhance(TrackOrders);
